// @mui
import { Box, Button } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
// theme
import { bgBlur } from 'src/theme/css';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';

// components
import Logo from 'src/components/logo';
//
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'src/hooks/use-local-storage';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import { useTableContext } from 'src/sections/table/context';
import { LOCAL_STORAGE_KEYS } from 'src/utils/constant';
import { HEADER, NAV } from '../config-layout';

// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
};

export default function Header({ onOpenNav }: Props) {
  const theme = useTheme();
  const { table_data } = useTableContext();
  const [countItems, setCountItems] = useState(0);
  const [bookInStorage] = useLocalStorage(LOCAL_STORAGE_KEYS.GUEST_BASKET, []);
  const lgUp = useResponsive('up', 'lg');
  const mdUp = useResponsive('up', 'md');

  useEffect(() => {
    const toNumber = Number(table_data);
    // console.log(table_data, toNumber);
    if (toNumber || toNumber === 0) setCountItems(table_data);
  }, [table_data]);

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: 1,
          bgcolor: 'background.default',
          height: HEADER.H_DESKTOP_OFFSET,
        }),
        borderBottom: `dashed 1px ${theme.palette.divider}`,
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
          justifyContent: 'space-between',
          width: 1,
          maxWidth: 1200,
          ...(mdUp && { width: `calc(100% - ${NAV.W_VERTICAL + 1}px)` }),
          mx: 'auto',
        }}
      >
        <Logo sx={{ mr: 2.5 }} href={paths.danh_cho_ban_doc.tra_cuu} />
        <Box>
          <Button
            LinkComponent={RouterLink}
            href={paths.guest.dang_ky_the}
            variant="text"
            sx={{ textDecoration: 'underline' }}
            color="primary"
          >
            Đăng ký thẻ
          </Button>
          {/* <IconButton LinkComponent={RouterLink} href={paths.guest.gio_sach}>
            <Badge badgeContent={countItems || bookInStorage?.length} color="primary">
              <Iconify icon="streamline:shopping-basket-1-solid" width={30} color={indigo[500]} />
            </Badge>
          </IconButton> */}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
